/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Header_Store_Link_Label1Inputs */

const vi_sitesettings_header_store_link_label1 = /** @type {(inputs: Sitesettings_Header_Store_Link_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chữ link cửa hàng`)
};

/**

* @param {Sitesettings_Header_Store_Link_Label1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_header_store_link_label1 = /** @type {((inputs?: Sitesettings_Header_Store_Link_Label1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Header_Store_Link_Label1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_header_store_link_label1(inputs)
});
export { sitesettings_header_store_link_label1 as "siteSettings_header_store_link_label" }